module.exports = __webpack_public_path__ + "img/1497231229.8e81b1d6.jpg";